<template>
    <main role="main">
      <div class="container-xxl py-4" >
        <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <!-- <h4 class="m-0">{{ $t("meetingCountDetails") }}</h4> -->
        <div>
          <b-button variant="outline-secondary" @click="getApiToken()">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("Lấy Token") }}
          </b-button>
        </div>
      </div>
        <!-- <span class="mt-2" style="overflow-wrap: break-word;">apiToken: {{ apiToken }}</span> -->
        <div style="display: flex;">
        <div class="d-flex menu">
           <ul class="menu-roll">
            <li><span style="font-size: 20px; font-weight: bold;">API</span></li>
            <li style="overflow: hidden;">
                <ul>
                    <li><a href="#/guideapi" @click="handlerReadApi('createAPI')">API Tạo cuộc họp</a></li>
                    <li><a href="#/guideapi" @click="handlerReadApi('getLinkAdminAPI')">API lấy URL tham gia với vai trò người điều hành</a></li>
                    <li><a href="#/guideapi" @click="handlerReadApi('getLinkUserAPI')">API Lấy URL tham gia với vai trò người tham dự</a></li>
                </ul>
            </li>
            <li><span style="font-size: 20px; font-weight: bold;">WIDGET</span></li>
           </ul>
        </div>
        <div v-if="api" class="api-content">
          <h5 class="mt-2 mb-4" style="overflow-wrap: break-word; font-weight: bold;">{{ api.name }}</h5>
            <dd>- Mô tả: <b>{{ api.description }}</b> </dd>
            <dd>- Link truy cập: <b>{{ api.link }}</b> </dd>
            <dd>- Method: {{ api.method }} </dd>
            <dd>- Authorization: {{ api.authorization }}</dd>
            <dd>- Media type: {{ api.mediaType }}</dd>
        <h5 class="mt-3 mb-4" style="font-weight: bold;">Tham số body</h5>
                <b-table striped hover bordered :fields="tableBodyFields" :items="requestAttr">
                    <template #cell(attribute)="data">
                        {{ data.item.attribute }}  <small style="color: red;">{{ data.item.require ? "(bắt buộc)" : "" }} </small>
                        <br>
                        <small>{{ data.item.type }}</small>
                    </template>
                </b-table>
                <h5 class="mt-3 mb-4" style="font-weight: bold;">Dữ liệu trả về</h5>
                <b-table striped hover bordered :fields="tableStatusFields" :items="code">
                </b-table>
                <b-table style="margin-top: 3em;" v-if="param.length != 0" striped hover bordered :fields="tableParamsFields" :items="param">
                </b-table>
            </div>
        </div>
    </div>
    </main>
</template>
<style lang="scss" scoped>
.content-add {
    display: block;
    position: relative;
    margin-bottom: 1.3rem;
    overflow: auto;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    /* padding: 15px; */
    line-height: 1.6em;
    font-size: inherit;
    white-space: nowrap;
    background: #e9ecef;
    margin: 10px 0;
}

.text-script {
    background: #E7E9EB;
    border: 0.5px solid #E7E9EB;
    border-radius: 5px;
    resize: none;
    line-height: 2;
    height: 100px;
}

.copy-button {
    position: absolute;
    top: 8px;
    right: 0;
    z-index: 2;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    /* height: 38px; */
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.menu {
    width: 30%;
}

.api-content {
    width: 65%;
}

ul,
li {
    list-style: none;
    margin-bottom: 5px
}

ul {
    padding-left: 1em;
}

.attr-width {
    width: 50%;
}

.menu-roll {
    position: fixed;
    width: 27%;
}
</style>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as userService from "@/service/userService";
import { BvTableFieldArray } from "bootstrap-vue";
import listApi from "@/list-api.json";

@Component
export default class GuideAPI extends BaseComponent {
    userId: number = userService.getCurrentUserId() || null;
    apiToken = null;
    listApi = listApi;
    api = null;
    requestAttr = [];
    code = [];
    param = [];
    tableBodyFields: BvTableFieldArray = [

        {
            key: "attribute",
            label: 'Thuộc tính',
            thStyle: "width: 35%",
        },
        {
            key: "description",
            label: this.$t("description").toString(),
            thClass: "text-nowrap",
        }];
    tableStatusFields: BvTableFieldArray = [

        {
            key: "statusCode",
            label: 'Status code',            
            thStyle: "width: 35%",
        },
        {
            key: "description",
            label: this.$t("description").toString(),
            thClass: "text-nowrap",
        }];
    tableParamsFields: BvTableFieldArray = [

        {
            key: "attribute",
            label: 'Tham số',            
            thStyle: "width: 35%",
        },
        {
            key: "description",
            label: this.$t("description").toString(),
            thClass: "text-nowrap",
        }];
    items = [{ attribute: 'sessionToken', required: 'Bắt buộc', description: 'Token để tham gia phòng họp' }]

    async mounted() {
        const user = await userService.getUser(this.userId);
        this.apiToken = user.apiToken;
        this.api = this.listApi.createAPI;
        this.requestAttr = this.api.request;
        this.code = this.api.response.code;
        console.log(this.api);
        
       
    }

    handlerReadApi(apiName) {
        this.api = this.listApi[apiName];
        
        this.requestAttr = this.api.request;
        this.code = this.api.response.code;
        if(this.api.response.params){
            this.param = this.api.response.params;
        }
        else {
            this.param = [];
        }
    }

    getApiToken() {
        navigator.clipboard.writeText(this.apiToken);
    }
}
</script>